import { Reveal, SectionHead } from "@/components/Reveal";
import { Icon } from "@/components/Icon";
import { PARTNER_OPPORTUNITIES, WHY_PARTNER, PARTNER_BRANDS } from "@/data/site";

export const Partners = ({ onJoin }) => (
  <section id="partners" className="relative py-32 sm:py-40 bg-[color:var(--kmg-deep)] grain" data-testid="partners-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <SectionHead
        eyebrow="06 — Partnership Opportunities"
        title="Let's grow together."
        sub="KMG Digi is looking for strategic partners who want to participate in building a stronger and more digitally connected agricultural ecosystem."
      />

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mt-20">
        {PARTNER_OPPORTUNITIES.map((p, i) => (
          <Reveal key={p.title} delay={i * 0.06}>
            <div
              data-testid={`partner-opportunity-${i}`}
              className="lift h-full border border-[rgba(111,227,155,0.16)] bg-[color:var(--kmg-forest)] p-7 hover:border-[color:var(--kmg-lime)]"
            >
              <Icon name={p.icon} size={21} className="text-[color:var(--kmg-lime)]" />
              <h3 className="font-display text-base mt-6 leading-snug">{p.title}</h3>
              <ul className="mt-5 space-y-2.5">
                {p.items.map((it) => (
                  <li key={it} className="text-[13px] text-[color:var(--kmg-bone-dim)] flex gap-2.5">
                    <span className="text-[color:var(--kmg-gold)]">·</span>
                    {it}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        ))}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-5 gap-8 mt-24 border-t border-[rgba(244,241,230,0.14)] pt-14">
        {WHY_PARTNER.map((w, i) => (
          <Reveal key={w.title} delay={i * 0.06}>
            <div data-testid={`why-partner-${i}`}>
              <Icon name={w.icon} size={20} className="text-[color:var(--kmg-lime)]" />
              <h4 className="font-display text-base mt-5">{w.title}</h4>
              <p className="text-sm mt-2 text-[color:var(--kmg-bone-dim)] leading-relaxed">{w.body}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1}>
        <div className="mt-24 border border-[rgba(111,227,155,0.2)] bg-[color:var(--kmg-forest)] p-10 sm:p-14 flex flex-col lg:flex-row lg:items-center justify-between gap-8">
          <div>
            <p className="eyebrow">In partnership with</p>
            <div className="flex flex-wrap gap-x-9 gap-y-4 mt-6">
              {PARTNER_BRANDS.map((b) => (
                <span key={b} className="font-display text-lg sm:text-xl text-[color:var(--kmg-bone-dim)]" data-testid={`partner-brand-${b.toLowerCase().replace(/\s+/g, "-")}`}>
                  {b}
                </span>
              ))}
            </div>
            <p className="font-editorial italic text-xl mt-8">Healthy Farms. Healthy People. A Sustainable Future.</p>
          </div>
          <button
            data-testid="partners-cta-btn"
            onClick={onJoin}
            className="shrink-0 rounded-full bg-[color:var(--kmg-lime)] px-9 py-4 text-sm font-semibold text-[color:var(--kmg-forest)] hover:bg-[#8df0b3]"
            style={{ transition: "background-color .4s ease" }}
          >
            Become a partner
          </button>
        </div>
      </Reveal>
    </div>
  </section>
);
